import GenericTableDto from 'modules/base/dto/table/GenericTableDto';
import GenericTableService from 'modules/base/service/GenericTableService';
import NamedDto from 'modules/base/dto/NamedDto';
import { format } from 'date-fns';

class OptimizerLogTableService extends GenericTableService {
	constructor() {
		super();
		this.CONTROL = 'optimizerLogTableControl';
	}

	/**
	* @param {string} session
	* @param {number} firstResult
	* @param {number} maxResults
	* @return {Promise<GenericTableDto<NamedDto>>}
	*/
	getList(session, firstResult, maxResults) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getList`, {
					session,
					firstResult,
					maxResults
				})
				.then(response => resolve(new GenericTableDto().setup(response.data, NamedDto)))
				.catch(reject);
		});
	}

	/**
	* @param {number} id
	* @return {Promise<any>}
	*/
	getRuns(id) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getRuns`, {
					id
				})
				.then(response => {
					let optionList = [];
					if (response.data) for (let i = 0; i < response.data.length; i += 1) optionList.push({ id: response.data[i].id, name: format(new Date(response.data[i].ts), 'yyyy.MM.dd. HH:mm:ss') + ' - ' + response.data[i].optimizer_name });
					resolve(optionList)
				})
				.catch(reject);
		});
	}

	/**
	* @param {number} id
	* @param {number} runId
	* @return {Promise<any>}
	*/
	getTrajectory(id, runId) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getTrajectory`, {
					id,
					runId
				})
				.then(response => { resolve(response) })
				.catch(reject);
		});
	}
}

export default new OptimizerLogTableService();
